module.exports = __webpack_public_path__ + "static/media/Evira final Cam 01-1.4d4826ab.webp";